const ROUTES = Object.freeze({
  BASE_PATH: '/',
  CREATE_ACCOUNT_PATH: 'create-account',
  VERIFY_EMAIL_PATH: 'verify-email',
  CONFIRM_ACCOUNT_PATH: 'confirm-account',
  ACCESS_CODE_PATH: 'access-code',
  CONTACT_US_PATH: '/contact-us',
  NOT_STARTED_PHOTO_SESSIONS: '/sessao-fotos/nao-iniciadas',
  RESCHEDULE_PHOTO_SESSIONS: '/sessao-fotos/reagendar',
  STARTED_PHOTO_SESSIONS: '/sessao-fotos/iniciadas',
  PHOTO_SESSION_DETAIL: '/sessao-fotos/detalhe/',
  PROFILE: '/meus-dados',
  PAYMENTS: '/pagamentos',
  ALL_PAYMENTS: '/pagamentos/todos',
  PENDING_PAYMENTS: '/pagamentos/pendentes',
  PAYMENT_DETAIL: '/pagamentos/detalhe/',
  INVOICE_ISSUANCE_DETAILS: '/pagamentos/nota-fiscal/instrucoes',
  PHOTOS_MANAGER: (type = ':house_type', id = ':house_id') =>
    `/photo/${type}/${id}`,
  PHOTOS_MANAGER_PHOTOSPHERE: (type = ':house_type', id = ':house_id') =>
    `/photosphere/${type}/${id}`,
  VIDEOS: (type = ':house_type', id = ':house_id') => `/video/${type}/${id}`,
  CHECKLIST: (id = ':id') => `/checklist/${id}`,
  CHECKLIST_EXTERNAL_AREA: (id = ':id') => `/checklist/${id}/area-externa`,
  CHECKLIST_GENERAL_CONDITIONS: (id = ':id') =>
    `/checklist/${id}/condicoes-gerais`,
  CHECKLIST_HOUSE: (id = ':id') => `/checklist/${id}/imovel`,
  NEW_CHECKLIST: (id = ':id') => `/new-checklist/${id}`,
  NEW_CHECKLIST_EXTERNAL_AREA: (id = ':id') =>
    `/new-checklist/${id}/area-externa`,
  NEW_CHECKLIST_HOUSE: (id = ':id') => `/new-checklist/${id}/imovel`,
  REPORT_ISSUE: (id = ':id') => `/reportar-problema/${id}`,
  RESCHEDULE_REPORTED_SESSION: (id = ':id') =>
    `/reportar-problema/${id}/reagendar`,
  RESCHEDULE_DATE_AND_TIME: (id = ':id') =>
    `/reportar-problema/${id}/escolher-data`,
  PROPERTY_ASSESSMENT: (id = ':id') => `/avaliacao/${id}`,
  PROPERTY_ASSESSMENT_SECTION: (id = ':id', slug = ':slug') =>
    `/avaliacao/${id}/${slug}`,
});

export const routesNames = Object.freeze({
  notStartedPhotoSessions: 'notStartedPhotoSessions',
  reschedulePhotoSessions: 'reschedulePhotoSessions',
  startedPhotoSessions: 'startedPhotoSessions',
  photoSessionDetail: 'photoSessionDetail',
  checklist: 'checklist',
  newChecklist: 'newChecklist',
  reportIssue: 'reportIssue',
  rescheduleReportedSession: 'rescheduleReportedSession',
  rescheduleDateAndTime: 'rescheduleDateAndTime',
  videos: 'videos',
  photosManager: 'photoManager',
  profile: 'profile',
  photosManagerPhotosphere: 'photosManagerPhotosphere',
  photospheres: 'photospheres',
  photos: 'photos',
  propertyAssessment: 'propertyAssessment',
  propertyAssessmentSection: 'propertyAssessmentSection',
  allPayments: 'allPayments',
  pendingPayments: 'pendingPayments',
  paymentDetail: 'paymentDetail',
  invoiceIssuanceDetails: 'invoiceIssuanceDetails',
});

export default ROUTES;
